import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100" aria-labelledby="category-title">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 id="category-title" className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            喷水设备分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            三大喷水系统领域，覆盖您的全部需求场景
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?tab=${cat.id}`}
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-3 left-4 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/90">
                    <i className={`${cat.icon} text-base text-primary-500`}></i>
                  </div>
                  <span className="text-white font-heading text-base font-semibold">{cat.name}</span>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">{cat.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{cat.articleCount} 篇相关文章</span>
                  <span className="text-sm text-primary-500 font-medium group-hover:translate-x-1 transition-transform duration-200 whitespace-nowrap">
                    了解更多 <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}